import { IPlanResponse } from "./service";
import {
  IVersionWithPrice,
  PricingPeriodEnum,
  PricingPlanVersionEnum,
  VersionWithPriceMapType,
} from "./types";

/**
 * 获取个人端网址
 * @returns
 */
export const getplatformUrl = () => {
  const host = window.location.host;
  if (host.startsWith("dev")) {
    return "https://devplatform.12times.com";
  } else if (host.startsWith("qas")) {
    return "https://qasplatform.12times.com";
  } else {
    return "https://platform.12times.com";
  }
};

/**
 * 判断是否在c端环境
 * @returns
 */
export const isInPlatform = () => {
  const host = window.location.host;
  return (
    host.startsWith("platform") ||
    host.startsWith("qasplatform") ||
    host.startsWith("devplatform") ||
    host.startsWith("uatplatform") ||
    host.startsWith("localhost")
  );
};

/**
 * 根据 id 获取版本信息
 * @param id
 * @param versionWithPrice
 * @returns
 */
export const getVersionById = (
  id: string,
  versionWithPrice: IVersionWithPrice[]
) => {
  return (
    versionWithPrice.find((item) => item.monthlyId === id) ||
    versionWithPrice.find((item) => item.yearlyId === id)
  );
};

/**
 * 根据版本和周期获取价格
 * @param priceInformation
 * @param version
 * @param period
 * @returns
 */
export const getPriceByVersionAndPeriod = (
  priceInformation: VersionWithPriceMapType,
  version: PricingPlanVersionEnum,
  period: PricingPeriodEnum
) => {
  if (!priceInformation[version]) {
    return 0;
  }

  switch (period) {
    case PricingPeriodEnum.MONTHLY:
      return priceInformation[version].monthlyPrice;
    case PricingPeriodEnum.YEARLY:
      return priceInformation[version].yearlyPrice;
  }
};

/**
 * 将计划响应转换为版本价格映射
 * @param planResponse
 * @returns
 */
export const transformPlanResponseToVersionWithPriceMap = (
  planResponse: IPlanResponse[]
) => {
  const result: Record<PricingPlanVersionEnum, Partial<IVersionWithPrice>> = {
    [PricingPlanVersionEnum.BASIC]: {
      version: PricingPlanVersionEnum.BASIC,
      versionNum: 1,
      label: "Basic",
    },
    [PricingPlanVersionEnum.PLUS]: {
      version: PricingPlanVersionEnum.PLUS,
      versionNum: 2,
      label: "Plus",
    },
    [PricingPlanVersionEnum.PRO]: {
      version: PricingPlanVersionEnum.PRO,
      versionNum: 3,
      label: "Pro",
    },
    [PricingPlanVersionEnum.ULTRA]: {
      version: PricingPlanVersionEnum.ULTRA,
      versionNum: 4,
      label: "Ultra",
    },
  };

  planResponse.forEach((item) => {
    if (
      item.memberPlan === PricingPlanVersionEnum.BASIC &&
      item.timeUnit === "MONTH"
    ) {
      result[PricingPlanVersionEnum.BASIC] = {
        ...result[PricingPlanVersionEnum.BASIC],
        monthlyId: item.goodsId,
        monthlyPrice: item.amount,
      };
    }

    if (
      item.memberPlan === PricingPlanVersionEnum.BASIC &&
      item.timeUnit === "YEAR"
    ) {
      result[PricingPlanVersionEnum.BASIC] = {
        ...result[PricingPlanVersionEnum.BASIC],
        yearlyId: item.goodsId,
        yearlyPrice: item.amount,
        yearlyPayTip: `立省 ${item.discountAmount} 元`,
      };
    }

    if (
      item.memberPlan === PricingPlanVersionEnum.PLUS &&
      item.timeUnit === "MONTH"
    ) {
      result[PricingPlanVersionEnum.PLUS] = {
        ...result[PricingPlanVersionEnum.PLUS],
        monthlyId: item.goodsId,
        monthlyPrice: item.amount,
      };
    }

    if (
      item.memberPlan === PricingPlanVersionEnum.PLUS &&
      item.timeUnit === "YEAR"
    ) {
      result[PricingPlanVersionEnum.PLUS] = {
        ...result[PricingPlanVersionEnum.PLUS],
        yearlyId: item.goodsId,
        yearlyPrice: item.amount,
        yearlyPayTip: `立省 ${item.discountAmount} 元`,
      };
    }

    if (
      item.memberPlan === PricingPlanVersionEnum.PRO &&
      item.timeUnit === "MONTH"
    ) {
      result[PricingPlanVersionEnum.PRO] = {
        ...result[PricingPlanVersionEnum.PRO],
        monthlyId: item.goodsId,
        monthlyPrice: item.amount,
      };
    }

    if (
      item.memberPlan === PricingPlanVersionEnum.PRO &&
      item.timeUnit === "YEAR"
    ) {
      result[PricingPlanVersionEnum.PRO] = {
        ...result[PricingPlanVersionEnum.PRO],
        yearlyId: item.goodsId,
        yearlyPrice: item.amount,
        yearlyPayTip: `立省 ${item.discountAmount} 元`,
      };
    }

    if (
      item.memberPlan === PricingPlanVersionEnum.ULTRA &&
      item.timeUnit === "MONTH"
    ) {
      result[PricingPlanVersionEnum.ULTRA] = {
        ...result[PricingPlanVersionEnum.ULTRA],
        monthlyId: item.goodsId,
        monthlyPrice: item.amount,
      };
    }

    if (
      item.memberPlan === PricingPlanVersionEnum.ULTRA &&
      item.timeUnit === "YEAR"
    ) {
      result[PricingPlanVersionEnum.ULTRA] = {
        ...result[PricingPlanVersionEnum.ULTRA],
        yearlyId: item.goodsId,
        yearlyPrice: item.amount,
        yearlyPayTip: `立省 ${item.discountAmount} 元`,
      };
    }
  });

  return result as VersionWithPriceMapType;
};

/**
 * 将版本价格映射转换为数组
 * @param versionWithPriceMap
 * @returns
 */
export const transformVersionWithPriceMapToArray = (
  versionWithPriceMap: VersionWithPriceMapType
) => {
  return Object.values(versionWithPriceMap);
};
